//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('orderLineCancelCause', {
//        templateUrl: 'views/components/views/orderLineCancelCause/orderLineCancelCause.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'orderLineCancelCauseService', function ($stateParams, stateService, translateService, modalService, orderLineCancelCauseService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let orderLineCauseKeyno = $stateParams.orderlinecancelcause_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                orderLineCancelCauseLangNameButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('orderlinecancelcauselang', { orderlinecancelcause_keyno: vm.model.edit.orderlinecancelcause_keyno }) }
//                ],
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadEdit() {
//                vm.model.edit = (await orderLineCancelCauseService.getOrderLineCancelCause({ orderlinecancelcause_keyno: orderLineCauseKeyno }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                orderLineCancelCauseService.saveObj(vm.model.edit).then((response) => {
//                    if (response[0] && response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: (dialogItself) => {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
